"use client";

import { createI18nClient } from "next-international/client";

// NOTE: Also update proxy.ts to support locale
export const languages = ["en", "es", "fr", "de", "pt"];

const {
  useScopedI18n,
  I18nProviderClient,
  useCurrentLocale,
  useChangeLocale,
  useI18n,
} = createI18nClient({
  en: () => import("./en"),
  es: () => import("./es"),
  fr: () => import("./fr"),
  de: () => import("./de"),
  pt: () => import("./pt"),
});

export {
  I18nProviderClient,
  useChangeLocale,
  useCurrentLocale,
  useI18n,
  useScopedI18n,
};
